import { render } from "./AgeWiseUserCount.vue?vue&type=template&id=806c4876"
import script from "./AgeWiseUserCount.vue?vue&type=script&lang=js"
export * from "./AgeWiseUserCount.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/teachers.gov.bd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__